import { Component, Input, OnInit } from '@angular/core';
import { SurveyApiService } from '../survey-api.service';
import { ToastrService } from 'ngx-toastr';


@Component({
    selector: 'survey-form',
    templateUrl: './survey-form.component.html',
    styleUrls: ['./survey-form.component.scss'],
    standalone: false
})
export class SurveyFormComponent implements OnInit {

  @Input()
  public questions: any;
  @Input()
  public getsurveyaddress: any;
  @Input()
  public isdatavalid: any;
  @Input()
  public commentcardStyles: any;
  @Input()
  public getsurveyelement: any;
  public descriptionHtml: any;
  isonlyText = false;


  constructor(private httpSurveyApi: SurveyApiService, private toastr: ToastrService) { }


  ngOnInit(): void {
    console.log(this.questions);
    this.isdatavalid = true;
    this.httpSurveyApi.questionList.subscribe((data) => {
      this.questions = data;
      if (!this.questions || (this.questions && this.questions.length == 1)) {
        this.isonlyText = true;
      }
    });

  }

  ngOnChanges() {
    let _input = this.getsurveyelement;
    if (_input) {
      // Plain string → Angular DomSanitizer runs on [innerHTML] (do not bypassSecurityTrustHtml)
      this.descriptionHtml = _input?.Payload?.FeedbackQuestionaryHeading ?? '';
    }
  }

  submit() {
    console.log(this.questions);
    this.httpSurveyApi.questionspost(this.questions, this.getsurveyaddress).subscribe(data => {
      console.log(data)
      if (data && data.State == 0) {
        this.toastr.success('Success!', 'Thank You for Your Feedback');
        this.isdatavalid = true;
        this.httpSurveyApi.dataSaved$.next(true);
      }
      else {
        let errormsg = "Unable to submit the feedback !!!";
        if (data && data.State == 1) {
          errormsg = data.ValidationMessages[0].Message;
        }
        this.toastr.error('Error!', errormsg);
      }
    },
      err => {
        console.log(err);
      });
  }
  onSearchChange(value) {
    if (this.isonlyText) {
      if (value) {
        this.isdatavalid = false;
      } else {
        this.isdatavalid = true;
      }

    }
  }

  reload() {
    location.reload();
  }
  checkaallselected() {
    this.isdatavalid = false;
    this.questions.forEach((element: any) => {
      if (element.rating == 0 && element.type != 'text') {
        this.isdatavalid = true;
        return;
      }
    });
  }

}
